// extracted by mini-css-extract-plugin
export default {"root":"NSNU0G","image-link":"CWbg1W","imageLink":"CWbg1W","image":"M0nFlw"};